function init_girls_suit(main,from_php){
    var girlSuit=main.find("#girl_suit");//suit
    var girlRoom=main.find("#girl_extend,#girl");
    var mode="room";
    var girlObj=new girlSuitView(from_php.girl_id,from_php.suit_active);
    function showSuit(){
        girlRoom.hide().css({'opacity':0});
        girlObj.makeView(girlSuit);
        var girl_conf={};
        girl_conf.left=intval(girlSuit.css("left"));
        girl_conf.top=intval(girlSuit.css("top"));
        girl_conf.width=intval(girlSuit.css("width"));
        girl_conf.height=intval(girlSuit.css("height"));
        main.find("#girlTrigger").css({left:girl_conf.left+"px",top:girl_conf.top+"px",width:girl_conf.width+"px",height:girl_conf.height+"px"});
    }
    function showRoom(){
        girlSuit.hide().css({'opacity':0});
        var girl_conf=$.takeGirlPositionConf(from_php.girl.girl_id,"10_1");
        main.find("#girlTrigger").css({left:girl_conf.left+"px",top:girl_conf.top+"px",width:girl_conf.width+"px",height:girl_conf.height+"px"});
        girlRoom.css({'opacity':0}).show().animate({'opacity':1},500);
    }
    function initSuit(){
        mode=_myStorage.get("suitGirl"+from_php.girl.girl_id);
        if(!mode){
            mode="room";
        }
        if(mode=="suit"){
            showSuit();
        }
        main.find("#suitChageJS").click(function(){
            if(mode=="room"){
                mode="suit";
            }
            else{
                mode="room";
            }
            if(mode=="room"){
                showRoom();
            }
            else{
                showSuit();
            }
            $(this).attr("data-type",mode);
            main.attr("data-suit_type",mode);
            _myStorage.set("suitGirl"+from_php.girl.girl_id,mode);
        }).attr("data-type",mode);
        main.attr("data-suit_type",mode);
        if(mode=="suit"){
            main.find("#girl_dialog").addClass("down");
        }
    }
    initSuit();
    //suit_active
    
    
    
    
    
   /*
    #girl_suit
    #girl_extend,#girl
    */
}